module.exports = __webpack_public_path__ + "media/images/venus-ffea1b989346c496bd1fdb608ef4a908.svg";